import { LocalStorageStore } from './LocalStorageStore';

export const DisplayedXeroSetupStore = new LocalStorageStore<string[]>(
  'XERO_SIGNUP_DISPLAYED_TO_USER_IDS',
  JSON.stringify,
  JSON.parse,
);
